import { motion, AnimateSharedLayout } from 'framer-motion';
import { CircularProgressbar } from 'react-circular-progressbar';
import useFetchCredential from '../../hooks/useFetchCredential';
import { UilMoneyWithdrawal } from '@iconscout/react-unicons';
import { formatter } from '../../utils/index.js';

const DashCards = () => {
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/commissions`
  );

  return (
    <div className="cards">
      {data && (
        <>
          <div className="parentContainer">
            <AnimateSharedLayout>
              <PremiumCard alltimeEarnings={data.alltimeEarnings} />
            </AnimateSharedLayout>
          </div>
          <div className="parentContainer">
            <AnimateSharedLayout>
              <SilverCard pendingBalance={data.pendingBalance} />
            </AnimateSharedLayout>
          </div>
          <div className="parentContainer">
            <AnimateSharedLayout>
              <GoldCard referrals={data.referrals} />
            </AnimateSharedLayout>
          </div>
        </>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '20px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '20px' }}>{error}</div>}
    </div>
  );
};

function PremiumCard({ alltimeEarnings }) {
  return (
    <motion.div
      className="CompactCard"
      style={{
        background: 'linear-gradient(180deg, #00BFA6 0%, #0cd3b8 100%)',
        boxShadow: '0px 10px 20px 0px #64f8e488',
      }}
      layoutId="expandableCard"
    >
      <div className="radialBar">
        <CircularProgressbar value="100" text={`100%`} />
        <span>All Time Earnings</span>
      </div>
      <div className="details">
        <UilMoneyWithdrawal />
        <span>{formatter.format(alltimeEarnings)}</span>
        <span>Since you joined</span>
      </div>
    </motion.div>
  );
}

function SilverCard({ pendingBalance }) {
  return (
    <motion.div
      className="CompactCard"
      style={{
        background: 'linear-gradient(180deg, #235A37 0%, #26683C 100%)',
        boxShadow: '0px 10px 20px 0px #13995f56',
      }}
      layoutId="expandableCard"
    >
      <div className="radialBar">
        <CircularProgressbar value="100" text={`100%`} />
        <span>Current Balance</span>
      </div>
      <div className="details">
        <UilMoneyWithdrawal />
        <span>{formatter.format(pendingBalance)}</span>
        <span>Since you joined</span>
      </div>
    </motion.div>
  );
}

function GoldCard({ referrals }) {
  return (
    <motion.div
      className="CompactCard"
      style={{
        background: 'linear-gradient(#BBD51A -146.42%, #cce627 -46.42%)',
        boxShadow: '0px 10px 20px 0px #F9D59B',
      }}
      layoutId="expandableCard"
    >
      <div className="radialBar">
        <CircularProgressbar value="100" text={`100%`} />
        <span>Referrals count</span>
      </div>
      <div className="details">
        <UilMoneyWithdrawal />
        <span>{referrals}</span>
        <span>Since you joined</span>
      </div>
    </motion.div>
  );
}

export default DashCards;
